// assets/min-order-checkout.js
document.addEventListener('DOMContentLoaded', function () {
  const CURRENCY = 'RON';

  // ===== FMR CONFIG (edit here) =====
  // IMPORTANT: cheile sunt normalizate (lowercase + trim)
  const VENDOR_MIN_RON = {
    'nannerl gmbh': 2000,
    'vecchi': 1500,
    // daca la tine vendorul apare ca "Vecchi S.p.A." / "Vecchi Italia" etc,
    // adaugi aici cheia exacta (normalizata)
  };
  // ==================================

  function normalizeVendor(v) {
    return String(v || '').trim().toLowerCase();
  }

  function parseBoolAttr(v) {
    const s = String(v || '').trim().toLowerCase();
    return s === 'true' || s === '1' || s === 'yes';
  }

  function parseMoneyNumber(v) {
    let s = String(v || '').trim();
    if (!s) return 0;
    s = s.replace(/[^\d.,]/g, '');
    if (s.includes('.') && s.includes(',')) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(',', '.');
    }
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  }

  function parseIntSafe(v, fallback = null) {
    const n = parseInt(String(v ?? '').trim(), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  // "in stoc" sau "stoc limitat" pentru OFFSET:
  // - available=false => nu
  // - inventory not managed + available=true => da
  // - inventory managed => qty > 0 => da
  function isInStockOrLow(itemEl) {
    const available = String(itemEl.getAttribute('data-variant-available') || '').toLowerCase() === 'true';
    if (!available) return false;

    const managed = String(itemEl.getAttribute('data-inventory-managed') || '').toLowerCase() === 'true';
    if (!managed) return true;

    const qty = parseIntSafe(itemEl.getAttribute('data-inventory-qty'), null);
    if (qty === null) return true;
    return qty > 0;
  }

  function getMinRONForVendor(vendorRaw) {
    const key = normalizeVendor(vendorRaw);
    return VENDOR_MIN_RON[key] || 0;
  }

  function collectGroups() {
    const groups = {};

    document.querySelectorAll('.cart-item').forEach(function (itemEl) {
      const vendorRaw = itemEl.getAttribute('data-product-vendor') || '';
      const vendorKey = normalizeVendor(vendorRaw);
      if (!vendorKey) return;

      const applyRule = parseBoolAttr(itemEl.getAttribute('data-apply-min-order'));
      
      const linePriceCents = parseInt(itemEl.getAttribute('data-line-price-cents') || '0', 10);
      if (!Number.isFinite(linePriceCents) || linePriceCents <= 0) return;

      // 1) incercam pragul din atribut (daca exista)
      const minAttr = itemEl.getAttribute('data-min-order-vendor') || '';
      let minRON = parseMoneyNumber(minAttr);

      // 2) fallback: prag din map vendor (asta te salveaza acum, pt ca min="" la tine)
      if (!minRON) {
        minRON = getMinRONForVendor(vendorRaw);
      }

      // titluri (pt lista produse vizate)
      const baseTitle = (itemEl.getAttribute('data-product-title') || '').trim();
      let variantTitle = (itemEl.getAttribute('data-variant-title') || '').trim();
      if (variantTitle.toLowerCase() === 'default title') variantTitle = '';
      const label = variantTitle ? `${baseTitle} – ${variantTitle}` : baseTitle;

      if (!groups[vendorKey]) {
        groups[vendorKey] = {
          vendor: vendorRaw.trim() || vendorKey,
          totalCents: 0,     // produse CU badge
          minRON: 0,
          products: [],      // lista produse CU badge
          inStockCents: 0,   // NOU: produse FARA badge, dar in stoc/stoc limitat
        };
      }

      if (applyRule) {
        groups[vendorKey].totalCents += linePriceCents;
        if (label) groups[vendorKey].products.push(label);
      } else {
        if (isInStockOrLow(itemEl)) {
          groups[vendorKey].inStockCents += linePriceCents;
        }
      }

      // pragul final pe vendor (daca mai multe linii au praguri, luam maximul, safe)
      if (minRON > groups[vendorKey].minRON) {
        groups[vendorKey].minRON = minRON;
      }

    });

    return groups;
  }

  function updateCartMinOrderBadges(groups) {
    const failedVendorSet = new Set(
      Object.values(groups)
        .filter((g) => {
          if (!g.minRON || g.minRON <= 0) return false;
          if (!g.totalCents || g.totalCents <= 0) return false; // regula doar daca exista produse CU badge

          const offsetRON = (g.inStockCents || 0) / 100;
          const effectiveMin = Math.max(0, g.minRON - offsetRON);

          return g.totalCents + 1e-9 < effectiveMin * 100;
        })
        .map((g) => normalizeVendor(g.vendor))
    );

    document.querySelectorAll('.cart-item').forEach((itemEl) => {
      const applyRule = parseBoolAttr(itemEl.getAttribute('data-apply-min-order') || '');
      if (!applyRule) return;

      const vendorRaw = itemEl.getAttribute('data-product-vendor') || '';
      const vendorNorm = normalizeVendor(vendorRaw);
      if (!vendorNorm) return;

      const badgeWrap = itemEl.querySelector('[data-min-order-cart-badge]');
      if (!badgeWrap) return;

      // Badge vizibil doar daca furnizorul e inca sub prag
      badgeWrap.style.display = failedVendorSet.has(vendorNorm) ? '' : 'none';
    });
  }

  function setCheckoutDisabled(disabled) {
    // buton checkout (poate fi in alta sectiune, cautam generic)
    const btns = Array.from(document.querySelectorAll('button[name="checkout"], [name="checkout"]')).filter(Boolean);

    btns.forEach((btn) => {
      if (!btn) return;
      if (disabled) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('button--disabled');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.classList.remove('button--disabled');
        btn.removeAttribute('aria-disabled');
      }
    });

    // butoane dinamice (Shop Pay etc.)
    document
      .querySelectorAll('.shopify-payment-button, .additional-checkout-buttons, .dynamic-checkout')
      .forEach((n) => (n.style.display = disabled ? 'none' : ''));
  }

  function renderWarning(failedGroups) {
  const warningEl = document.getElementById('tag-min-total-warning');
  if (!warningEl) return;

  if (!failedGroups.length) {
    warningEl.style.display = 'none';
    warningEl.innerHTML = '';
    return;
  }

  const blocks = failedGroups
    .map((g) => {
      const totalRON = (g.totalCents / 100).toFixed(2);

      const offsetRON_num = (g.inStockCents || 0) / 100;
      const effectiveMin_num = Math.max(0, (g.minRON || 0) - offsetRON_num);

      //const minRON = Number(g.minRON || 0).toFixed(2);
      //const offsetRON = offsetRON_num.toFixed(2);
      const effectiveMin = effectiveMin_num.toFixed(2);

      const missingRON = Math.max(0, effectiveMin_num - g.totalCents / 100).toFixed(2);

      const products = Array.from(new Set(g.products || [])); // fara dubluri
      const preview = products.slice(0, 3);
      const rest = products.slice(3);

      const productsHtml = products.length
        ? `
          <div class="min-order-products">
            <div class="min-order-products__title">Produse ce necesită comandă minimă:</div>
            ${preview.map((p) => `<div>• ${p}</div>`).join('')}
            ${
              rest.length
                ? `
                  <details class="min-order-details">
                    <summary>+ ${rest.length} produse</summary>
                    <div class="min-order-products">
                      ${rest.map((p) => `<div>• ${p}</div>`).join('')}
                    </div>
                  </details>
                `
                : ''
            }
          </div>
        `
        : '';


      return `
        <div class="min-order-card">
          <div class="min-order-card__title">
            🧩 Comandă minimă pentru furnizorul <strong>${g.vendor}</strong>
          </div>

          <div class="min-order-card__line">
            Comandă minimă: <strong>${effectiveMin} ${CURRENCY}</strong>
            <span class="min-order-sep">|</span>
            Ai până acum: <strong>${totalRON} ${CURRENCY}</strong>
          </div>

          <div class="min-order-card__line min-order-card__need">
            Mai ai nevoie de: <strong>${missingRON} ${CURRENCY}</strong>.
          </div>

          <div class="min-order-card__hint">
            Adaugă produse de la furnizorul ${g.vendor} ca să atingi comanda minimă.
          </div>

          ${productsHtml}
        </div>
      `;
    })
    .join('');

  warningEl.style.display = 'block';
  warningEl.innerHTML = `<div class="min-order-warning-wrapper">${blocks}</div>`;
}


  function updateMinOrderState() {
    const groups = collectGroups();
    updateCartMinOrderBadges(groups);

    const failed = Object.values(groups).filter((g) => {
      if (!g.minRON || g.minRON <= 0) return false;

      // regula se aplica doar daca exista produse CU badge
      if (!g.totalCents || g.totalCents <= 0) return false;

      const haveRON = g.totalCents / 100;
      const offsetRON = (g.inStockCents || 0) / 100;
      const effectiveMin = Math.max(0, g.minRON - offsetRON);

      return haveRON + 1e-9 < effectiveMin;
    });

    renderWarning(failed);
    setCheckoutDisabled(failed.length > 0);
  }

  // ===== trigger-uri =====
  updateMinOrderState();

  // cantitate schimbata
  document.addEventListener(
    'change',
    function (e) {
      const t = e.target;
      if (!t) return;
      if (t.matches('input[name="updates[]"], .quantity__input')) {
        setTimeout(updateMinOrderState, 150);
      }
    },
    true
  );

  // plus/minus/remove
  document.addEventListener(
    'click',
    function (e) {
      const el = e.target && e.target.closest && e.target.closest('button, a');
      if (!el) return;

      if (el.matches('.quantity__button') || el.closest('cart-remove-button')) {
        setTimeout(updateMinOrderState, 250);
      }
    },
    true
  );

  // rerender Dawn pe cart
  const main = document.getElementById('main-cart-items');
  if (main && 'MutationObserver' in window) {
    const obs = new MutationObserver(function () {
      clearTimeout(window.__fmrMinOrderT);
      window.__fmrMinOrderT = setTimeout(updateMinOrderState, 100);
    });
    obs.observe(main, { childList: true, subtree: true });
  }
});
